/**
 * form下载
 * 参数：
 * {
 *     params: {             // 操作需要的参数
 *          billId: '',
 *          ...
 *     },
 *     url: '',             // 操作的url
 *     enctype: 1/2/3       // form提交的方式  1和默认、multipart/form-data 2、application/x-www-form-urlencoded 3、text/plain
 * }
 */
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Modal, ProgressBar } from "@platform/base";
import { getAppReqParam, getGlobalStorage, getMultiLang, toast, clearToast, myBrowser, Cipher, gzip as Gzip, ajax, getScreenZoom, getTheme, microAppUtil, getSafeRandom } from "@platform/api";
const { opaqueDecrypt } = Cipher;
import './index.less';

function isSafari() {
    return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
}

function guid(){
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = getSafeRandom() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export function getCipherData(data, { isOnlyAES = false } = {}) {

    let NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch')) || {};
    let cipherFlag = NCC_SYS_Switch.aesKey;
    let gzip = NCC_SYS_Switch.gzip;
    //压缩开关
    //let gzip = getGlobalStorage('localStorage', 'gzip');
    let gziptools = new Gzip();

    let gData = data;

    //加密开关
    //let cipherFlag = getGlobalStorage('localStorage', 'rockin');
    // Cipher.CipherFlag = cipherFlag;

    //加密密钥
    let aeskey = opaqueDecrypt(getGlobalStorage('localStorage', 'cowboy'));

    if (gzip) {
        if (typeof gData !== 'string') {
            gData = JSON.stringify(gData);
        }
        gData = gziptools.zip(gData);
    }
    if (cipherFlag) {
        return Cipher.encrypt(gData, aeskey, isOnlyAES);
    } else {
        return gData;
    }
}

export function getDecryptData(data) {
    //加密开关
    let NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch')) || {};
    let cipherFlag = NCC_SYS_Switch.aesKey;
    let gzip = NCC_SYS_Switch.gzip;

    let gziptools = new Gzip();
    //加密密钥
    let aeskey = opaqueDecrypt(getGlobalStorage('localStorage', 'cowboy'));
    // Cipher.CipherFlag = cipherFlag === 'true';

    data = (typeof data === 'string') ? cipherFlag ? Cipher.decrypt(data, aeskey) : data : data;
    if (gzip == '1') {
        return gziptools.unzip(data);
    } else {
        return typeof data == 'string' ? JSON.parse(data) : data;
    }
}

class PrintModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: true,
            json: {},
        };
        this.iframeId = 'printInModalFrame-' + guid();
    }
    UNSAFE_componentWillMount() {
        let callback = (json, bool) => {
            if (bool) {
                this.setState({ json });
            }
        };
        getMultiLang({ moduleId: "api_formDownload", callback });
    }

    componentDidMount() {
        let broswer = myBrowser();
        if (broswer == 'Chrome' || broswer == 'Edge') {
            document.getElementById('downloadBtn').style.display = 'block';
        }
        if (this.props.params.outputType == 'output') {
            return;
        }
        let printIframe = document.getElementById(this.iframeId);
        let iframeLoading = `
            <div style="transform: rotate(0deg);opacity:calc(12 / 12);animation: part1 1.2s linear 0.1s infinite;"></div>
            <div style="transform: rotate(30deg);opacity:calc(11 / 12);animation: part1 1.2s linear 0.2s infinite;"></div>
            <div style="transform: rotate(60deg);opacity:calc(10 / 12);animation: part1 1.2s linear 0.3s infinite;"></div>
            <div style="transform: rotate(90deg);opacity:calc(9 / 12);animation: part1 1.2s linear 0.4s infinite;"></div>
            <div style="transform: rotate(120deg);opacity:calc(8 / 12);animation: part1 1.2s linear 0.5s infinite;"></div>
            <div style="transform: rotate(150deg);opacity:calc(7 / 12);animation: part1 1.2s linear 0.6s infinite;"></div>
            <div style="transform: rotate(180deg);opacity:calc(6 / 12);animation: part1 1.2s linear 0.7s infinite;"></div>
            <div style="transform: rotate(210deg);opacity:calc(5 / 12);animation: part1 1.2s linear 0.8s infinite;"></div>
            <div style="transform: rotate(240deg);opacity:calc(4 / 12);animation: part1 1.2s linear 0.9s infinite;"></div>
            <div style="transform: rotate(270deg);opacity:calc(3 / 12);animation: part1 1.2s linear 1s infinite;"></div>
            <div style="transform: rotate(300deg);opacity:calc(2 / 12);animation: part1 1.2s linear 1.1s infinite;"></div>
            <div style="transform: rotate(330deg);opacity:calc(1 / 12);animation: part1 1.2s linear 1.2s infinite;"></div>`;
        let iframeDom = printIframe.contentWindow.document.createElement('div');
        let style = printIframe.contentWindow.document.createElement('style');
        style.innerHTML = `.part-box{position:absolute;top:45%;left:45%}.part-box div{position:absolute;top:48px;left:30px;width:3px;height:13px;border-radius:16px;background:rgba(107,107,107);transform-origin:center -16px;}@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}@keyframes part1{0%{opacity:calc(0 / 12)}8.333333333333334%{opacity:calc(1 / 12)}16.666666666666667%{opacity:calc(2 / 12)}24.999999999999996%{opacity:calc(3 / 12)}33.33333333333333%{opacity:calc(4 / 12)}41.66666666666666%{opacity:calc(5 / 12)}49.99999999999999%{opacity:calc(6 / 12)}58.33333333333333%{opacity:calc(7 / 12)}66.66666666666666%{opacity:calc(8 / 12)}74.99999999999999%{opacity:calc(9 / 12)}83.33333333333331%{opacity:calc(10 / 12)}91.66666666666666%{opacity:calc(11 / 12)}100%{opacity:calc(12 / 12)}}`;
        iframeDom.classList.add('part-box');
        iframeDom.innerHTML = iframeLoading;
        printIframe.contentWindow.document.body.appendChild(iframeDom);
        printIframe.contentWindow.document.head.appendChild(style);
        printIframe.onload = () => {
            setTimeout(() => {
                setIframeDom(printIframe, broswer);
            }, 1000);
        };
    }
    modalDownload = obj => {
        let downloadParam = Object.assign({}, obj);
        downloadParam.previewInModal = false;
        //downloadParam.target = "_self";
        //downloadParam.params.outputType = 'output';
        downloadParam.params.browserdownloadtype = "brow_out";
        formDownload(downloadParam);
    }

    render() {
        let { json } = this.state;
        console.log('2323--', getScreenZoom());
        let zoom = getScreenZoom() || 1;
        return (
             <Modal visible={this.state.showModal} {...this.props} size="xlg" width="98%" height="96%" fieldid="print-template">
                <Modal.Header closeButton>
                    <div id="downloadBtn" className="close iconfont icon-xiazai1 base-modal-header-xiazai" onClick={() => { return this.modalDownload(this.props); }}></div>
                    <Modal.Title fieldid="print-template">
                        <span>{json["api-formDownload-0002"]}</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="ncc-print-modal">
                        <div className="numberPrintMask" style={{ right: Math.floor(156/zoom), top: Math.floor(12/zoom) }}></div>
                        <div className="printMask" style={{ right: Math.floor(85/zoom), top: Math.floor(14/zoom) }}></div>
                        <div className="edgeMask" style={{ right: Math.floor(46/zoom), top: Math.floor(0/zoom) }}></div>
                        {/* <div className="printReadMask" style={{ right: Math.floor(85/zoom), top: Math.floor(18/zoom) }}></div> */}
                        <iframe name={this.props.iframeName} id={this.iframeId} frameBorder="0" width="100%" height="98%"></iframe>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

function setIframeDom(dom, broswer) {
    let bgValue, fontColor;
    if (broswer == 'IE') {
        let nowTheme = getGlobalStorage('localStorage', 'nccColor');
        if (nowTheme == 'black') {
            bgValue = '#0f0f0f';
            fontColor = '#d9d9d9';
        } else {
            bgValue = '#ffffff';
            fontColor = '#363636';
        }
    } else {
        bgValue = document.documentElement.style.getPropertyValue('--pui-black-derived-color-11') || '#ffffff';
        fontColor = document.documentElement.style.getPropertyValue('--pui-black-font-color-3') || '#363636';
    }
    dom.contentWindow.document.body.style.backgroundColor = bgValue;
    dom.contentWindow.document.body.style.color = fontColor;
    if (dom.contentWindow.document.getElementsByTagName('embed').length !== 0) {
        if (myBrowser() == '360'){
            document.querySelector('.numberPrintMask').style.display = 'block';
        }else if (myBrowser() == 'Edge') {
            // document.querySelector('.printReadMask').style.display = 'block';
            document.querySelector('.edgeMask').style.display = 'block';
        } else if (myBrowser() == 'Chrome') {
            document.querySelector('.printMask').style.display = 'block';
        }
    }
}

/**
 * @namespace FormDownload
*/

/**
 * FormParam参数说明
 * @memberof FormDownload
 * @typedef FormParam
 * @property {string} url 提交请求后台地址
 * @property {number} enctype=1 值为1表示'multipart/form-data';<br/>值为2表示'application/x-www-form-urlencoded'; <br/>值为3表示'text/plain'; <br/>默认为'multipart/form-data'
 * @property {string} target=_blank '_blank':提交成功后，新页签打开后台页面; <br/>'_self':提交成功后，在当前页打开后台页面;<br/> 默认值为'_blank'
 * @property {boolean} previewInModal=false 在弹窗内预览后台返回页面
 * @property {Object} params 表单请求参数
*/

/**
 * 表单提交
 * @memberof FormDownload
 * @param {FormParam} props
 */
export function formDownload(props) {
    let iframeName = 'printFrame-' + guid();
    if (props.previewInModal) {
        let div = document.createElement('div');
        if (props.params.outputType == 'output') {
            div.style.display = 'none';
        }
        microAppUtil.getDocument().appendChild(div);
        ReactDOM.render(<PrintModal {...props} getPopupContainer={div} iframeName={iframeName}></PrintModal>, div, () => { downloadFun(props, iframeName); });
    } else {
        downloadFun(props, iframeName);
    }

}

function downloadFun({
    params,
    url,
    enctype,
    target,
    callback,
    previewInModal = false,
    //isCipher = false,
    //isMergeReqData = false,
}, iframeName) {
    let isCipher = true, isMergeReqData = true;
    // 从ajax哪里取得，目的获取busiaction
    let { app, appcode, custom } = getAppReqParam();

    let busiaction = `${app || null}-${window.actionName || null}`,
        sysTs = String(new Date().getTime());
    let sysParamJson = {
        sys_busiaction: busiaction,
        sys_appcode: params.sys_appcode || appcode,
        sys_ts: sysTs,
        sys_custom: custom,
        // busiaction: busiaction ,
        // appcode: appcode,
        // ts: new Date().getTime()
    };
    enctype = (type => {
        switch (type) {
            case 1:
                return 'multipart/form-data';
            case 2:
                return 'application/x-www-form-urlencoded';
            case 3:
                return 'text/plain';
            default:
                return 'multipart/form-data';
        }
    })(enctype);

    if (params.outputSetting) {
        params.outputSetting = JSON.stringify(Object.assign({}, JSON.parse(params.outputSetting), { taskID: sysTs }));
    }
    params.theme = getTheme(false);
    //const config = { ...params, ...sysParamJson };
    let isOutput = params.output || false,
        queryUrl = params.queryUrl || "";

    // if(isOutput && !previewInModal && iframeName){
    //     let iframe = document.createElement('iframe');
    //     iframe.name = iframeName;
    //     iframe.style.width = 0; 
    //     iframe.style.height = 0; 
    //     microAppUtil.getDocument().appendChild(iframe);
    // }

    let resetTarget = '';
    if (previewInModal) {
        resetTarget = iframeName;
    } else {
        resetTarget = target ? target : isOutput ? "_self" : '_blank';
    }
    const [attrs, el_form] = [
        {
            target: resetTarget,
            // target: target ? target : isOutput ? "_self" : '_blank',
            method: 'POST',
            enctype,
            type: 'hidden',
            action: url || '',
        },
        document.createElement('form'),
    ];
    Object.assign(el_form, attrs);

    if (isMergeReqData) {
        // 批量提交系统参数
        sysParamJson = JSON.stringify(sysParamJson);
        let sysInput = document.createElement('input');
        sysInput.type = 'hidden';
        sysInput.name = 'sysParamJson';
        sysInput.value = isCipher ? getCipherData(sysParamJson) : sysParamJson;
        el_form.appendChild(sysInput);

        let sysAppcode = document.createElement('input');
        sysAppcode.type = 'hidden';
        sysAppcode.name = 'sys_appcode';
        sysAppcode.value = params.sys_appcode || appcode;
        el_form.appendChild(sysAppcode);
        // 循环提交系统参数
        // for (let key in sysParamJson) {
        //     let input = document.createElement('input');
        //     input.type = 'hidden';
        //     input.name = key;
        //     input.value = sysParamJson[key];
        //     el_form.appendChild(input);
        // }

        // 批量提交业务参数
        let busiParamJson = JSON.stringify(params);
        let busiInput = document.createElement('input');
        busiInput.type = 'hidden';
        busiInput.name = 'busiParamJson';
        busiInput.value = isCipher ? getCipherData(busiParamJson) : busiParamJson;
        el_form.appendChild(busiInput);
    } else {
        // 循环提交系统参数
        for (let key in sysParamJson) {
            let input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = sysParamJson[key];
            el_form.appendChild(input);
        }
        // 循环提交业务参数
        for (let key in params) {
            if (params[key] instanceof Array) {
                params[key].forEach(item => {
                    let input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = isCipher ? getCipherData(item) : item;
                    el_form.appendChild(input);
                });
            } else {
                let input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = isCipher ? getCipherData(params[key]) : params[key];
                el_form.appendChild(input);
            }
        }
    }

    document.body.appendChild(el_form);
    el_form.submit();
    document.body.removeChild(el_form);
    let getJsonCallback = json => {
        toast({
            title: json["api-formDownload-0001"],
            content: <OutProcess sysTs={sysTs} queryUrl={queryUrl} mark={sysTs} taskEnd={callback} />,
            mark: sysTs,
            duration: 999999,
            className: "export-procress-toast",
        },
        );
    };

    //safari先不支持查询进度 NCC-178920
    !isSafari() && isOutput && params.outputSetting && getMultiLang({ moduleId: "api_formDownload", callback: getJsonCallback });
    return false;
}

function checkType(param, type) {
    return Object.prototype.toString.call(param).slice(8, -1).toLowerCase() === type.toLowerCase();
}

class OutProcess extends Component {
    constructor(props) {
        super(props);
        this.state = { outProNum: 0 };
    }

    componentDidMount() {
        this.begProcess(this.props.sysTs, this.props.queryUrl, this.props.mark);
    }

    begProcess = (sysTs, queryUrl, mark) => {
        ajax({
            url: this.props.queryUrl || "/nccloud/riart/out/outtask.do",
            data: { taskID: sysTs.toString() },
            datatype: "json",
            loading: false,
            success: res => {
                let { success, data } = res;
                if (!success || !data) {return;}
                if (checkType(data.rate, "Null")) {
                    data.rate = 0;
                }
                data.rate < 100 && setTimeout( () => {this.begProcess(sysTs, queryUrl, mark);}, 1000) ;
                if (data.rate == 100) {
                    setTimeout(() => {
                        clearToast(mark);
                        typeof this.props.taskEnd == "function" && this.props.taskEnd();
                    }, 500);
                }
                this.setState({ outProNum: data.rate });
            },
            error: res => {
                clearToast(mark);
                toast({ color: "error", content: res.message });
                console.log(res.message);
            },
        });
    }

    render() {
        const { outProNum } = this.state;
        return <ProgressBar size="xs" now={outProNum} label={`${outProNum}%`} />;
    }
}
